<template>
  <div class="flex items-center justify-center w-100 h-screen bg-grey-lightest">
    <div class="login max-w-lg">
      <h1 class="mb-3">Log In</h1>
      <form v-on:submit.prevent="logIn">
        <input class="p-3 shadow-inner" v-model="email" type="text" placeholder="email" />
        <input class="p-3 shadow-inner" v-model="password" type="password" placeholder="password"/>
        <v-button
          type="submit"
          :click="logIn"
          text="Submit"
        ></v-button>
      </form>
      <p v-if="errorMessage">{{ errorMessage }}</p>
      <p class="mt-3">New user <router-link to="/signup">Sign Up</router-link></p>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import Button from '../components/Button.vue';

export default {
  name: 'Login',
  components: {
    'v-button': Button,
  },
  data() {
    return {
      password: null,
      email: null,
      errorMessage: null,
    };
  },
  methods: {
    logIn() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .catch((error) => {
          // var errorCode = error.code;
          this.errorMessage = error.message;
        })
        .then(() => {
          this.$store.dispatch('setUser');
          this.goToPicker();
        });
    },
    goToPicker() {
      this.$router.push({ name: 'Picker' });
    },
  },
};
</script>

<style lang="scss">
</style>
